import { defineStore } from 'pinia'

export const useGeneralTableStore = defineStore({
  id: 'generalTable',
  state: () => ({
    page: 0, // 0 means not set
    fetchPage: 1,
    totalPages: 1,
    search: '',
    orderBy: 'id',
    orderByDir: 'desc',
    perPage: 10,
    total: 0,
    url: '',
    data: {
        //page# : rows
    },
    loading: false,
    loadingSelectAll: false,
    hovering: null, /* row id */

    itemNoun: 'item',

    filterOpen: false,
    availableFilters: [],
    activeFilters: [],

    applyFilterByValue: null, // linked function for filterPanel
    selected: [], // selected rows
    selectActions: [],  
    
  }),
  getters: {
    items() {
        this.loading; //makes sure items gets updated when things may refresh
        return this.data[this.page] || [];
    },
    itemNounPlural() {
        return this.itemNoun + 's';
    },
    totalFormatted() {
        return this.total.toLocaleString();
    },
    selectedFormatted() {
        return this.selected.length.toLocaleString();
    },
    selectedNoun() {
        return this.selected.length === 1 ? this.itemNoun : this.itemNounPlural;
    },
    getPagingUrlParams() {
        const params = {};

        if (this.fetchPage) {
            params.page = this.fetchPage;
        }
        if (this.perPage) {
            params.per_page = this.perPage;
        }
        if (this.search) {
            params.search = this.search;
        }
        if (this.orderBy) {
            params.order_by = this.orderBy;
        }
        if (this.orderByDir) {
            params.order_by_dir = this.orderByDir;
        }

        return params;
    },
    getFilterUrlParams() {
        const params = {};
        if (!this.activeFilters.length) {
            return params;
        }

        this.activeFilters.forEach(filter => {
            const filterKey = filter.filter.value;
            const filterValue = filter.urlValue ? filter.urlValue : filter.value;
        
            // Check if the parameter is expected to handle multiple values
            if (filter.multiple) {
                // If the parameter expects multiple values but doesn't exist yet, initialize it as an array
                if (!params.hasOwnProperty(filterKey)) {
                    params[filterKey] = [filterValue];
                } else {
                    // If it already exists (and should be an array), just push the new value
                    params[filterKey].push(filterValue);
                }
            } else {
                // If the filter doesn't expect multiple values, simply assign it
                params[filterKey] = filterValue;
            }
        });

        return params;
    },
    combinedUrlParams() {
        this.page; // for some reason, page wasn't triggering an update??
        return {
            ...this.getPagingUrlParams,
            ...this.getFilterUrlParams
        };
    }
  },
  actions: {
    clearData(opts = {}) {
        const defaultOpts = {
            resetPage: true,
            clearFilters: false,
            clearSearch: false,
            clearSelected: true,
            clearOrderBy: true,
        };
        opts = {...defaultOpts, ...opts};

        if (opts.resetPage) {
            this.fetchPage = 1;
            this.page = 0; //reset so no items show
        }
        if (opts.clearSelected) {
            this.selected = [];
        }

        if (opts.clearOrderBy) {
            this.orderBy = 'id';
            this.orderByDir = 'desc';
        }

        if (opts.clearSearch) {
            this.search = "";
        }

        this.data = {};
    },
    fetchData() {
        if (!this.url) return;
        this.loading = true;
        axios.get(this.url, {
            params: this.combinedUrlParams
        }).then(response => {
            this.data[response.data.meta.current_page] = response.data.data;
            this.page = response.data.meta.current_page;
            this.totalPages = response.data.meta.total_pages;
            this.total = response.data.meta.total;
        }).catch(error => {
          console.error(error)  
        }).finally(() => {
            this.loading = false;
        });
    },
    selectAll() {
        //we're going to run similar to fetch data, but start at page 1, and "per page", we'll set to 99999 to get all records
        this.loadingSelectAll = true;
        axios.get(this.url, {
            params: {
                ...this.combinedUrlParams,
                page: 1,
                per_page: 99999
            }
        }).then(response => {
            if (!response.data.data.length) {
                return;
            }

            let firstItem = response.data.data[0];
            let itemId = 'id';
            if (firstItem.tra_id) {
                itemId = 'tra_id';
            }

            response.data.data.forEach(item => {
                let itemExists = this.selected.find(selectedItem => selectedItem[itemId] === item[itemId]);
                if (!itemExists) {
                    this.selected.push(item);
                }
            });
        }).catch(error => {
            console.error(error)  
        }).finally(() => {
            this.loadingSelectAll = false;
        });

    },
    setPage(pageNumber) {
        //see if we have this page's data before we fetch
        if (this.data[pageNumber]) {
            this.page = pageNumber;
            return;
        }

        this.fetchPage = pageNumber;
        this.fetchData();
    },
  }
});